import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { palette } from '@openx/components-core/lib/theme/paletteV2';
import { FunnelDiscardArrow } from './FunnelDiscardArrow';
import { FunnelForwardArrowHeadIcon } from './FunnelForwardArrowHeadIcon';

type FunnelStepArrowProps = {
  forwardedPercentage: string;
  discardedPercentage: string;
  isCurrentValueAllDiscarded: boolean;
  isPreviousStepForwardingValue: boolean;
};

const styles: { [key: string]: SxProps<Theme> } = {
  arrowLine: {
    height: '100%',
    minHeight: '80px',
    width: '35px',
  },
  container: {
    display: 'flex',
    height: '100%',
  },
  discardContainer: {
    alignItems: 'flex-end',
    display: 'flex',
    flexDirection: 'column',
    left: '-15px',
    marginRight: '-15px',
    position: 'relative',
  },
  forwardedPercentage: {
    marginTop: theme => theme.spacing(1),
  },
  mainArrow: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
};

export const FunnelStepArrow = ({
  forwardedPercentage,
  discardedPercentage,
  isCurrentValueAllDiscarded,
  isPreviousStepForwardingValue,
}: FunnelStepArrowProps) => {
  const backgroundColor = isPreviousStepForwardingValue ? palette.success.main : palette.background.boxDarkest;
  const opacity = !isPreviousStepForwardingValue && isCurrentValueAllDiscarded ? 0 : 1;
  return (
    <Box sx={styles.container}>
      <Box sx={styles.mainArrow}>
        <Box
          data-test="funnel-main-arrow-line"
          sx={{
            ...styles.arrowLine,
            backgroundColor,
          }}
        />
        <FunnelForwardArrowHeadIcon
          data-test="funnel-forward-arrow-head"
          style={{ fill: backgroundColor, flexShrink: 0 }}
        />
        <Typography variant="body1Bold" color={palette.text.secondary} sx={styles.percentage}>
          {forwardedPercentage}
        </Typography>
      </Box>
      <Box sx={styles.discardContainer}>
        <FunnelDiscardArrow
          data-test="funnel-discard-arrow"
          isCurrentValueAllDiscarded={isCurrentValueAllDiscarded}
          style={{ opacity }}
        />
        {isPreviousStepForwardingValue && (
          <Typography variant="body1Bold" color={palette.text.secondary}>
            {discardedPercentage}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
